// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"CQ-z","categoryName":"DQ-z","categoryNameSearchHeader":"EQ-z","categoryContent":"FQ-z","bottomAligned":"GQ-z","image":"HQ-z","imageNoBackground":"IQ-z"};